import React from 'react';
import './LegalDocumentPage.css';
import PageButton from '../../elements/PageButton/PageButton';
import {usePageAnalytics} from '../../../hooks/analytics/usePageAnalytics';

function LegalDocumentPage({pageId, content, onBack}) {
  usePageAnalytics(pageId);

  return (
    <>
      <PageButton
        className="legal-floating-back-button"
        onClick={onBack}
        pageId={pageId}
        buttonId="back_floating"
      >
        <img
          className="legal-floating-back-button_icon"
          src="/img/icons/back_navigation.png"
          alt="Назад"
          title="Назад"
        />
      </PageButton>

      <h1 className="legal-page-title">{content.title}</h1>

      <div className="legal-content">
        {content.updatedAt && (
          <p className="legal-updated-at">{content.updatedAt}</p>
        )}
        {content.blocks.map((block, index) => {
          if (block.type === 'heading') {
            return <h2 key={index} className="legal-heading">{block.text}</h2>;
          }
          if (block.type === 'listItem') {
            return <p key={index} className="legal-list-item">{block.text}</p>;
          }
          if (block.type === 'emailLink') {
            return (
              <p key={index} className="legal-paragraph">
                {block.label}
                <br/>
                <a className="legal-email-link" href={block.mailtoHref || `mailto:${block.email}`}>
                  {block.email}
                </a>
              </p>
            );
          }
          return <p key={index} className="legal-paragraph">{block.text}</p>;
        })}
      </div>

      <div className="main-menu-buttons">
        <PageButton onClick={onBack} pageId={pageId} buttonId="back">
          Назад
        </PageButton>
      </div>
    </>
  );
}

export default LegalDocumentPage;
